
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.408 11.016c-.234 0-.448-.074-.64-.224-.192-.138-.288-.373-.288-.704 0-.32.102-.618.304-.896.192-.266.443-.517.752-.752.31-.224.646-.432 1.008-.624L3.6 7.272c.15-.373.288-.773.416-1.2.14-.437.272-.917.4-1.44a8.032 8.032 0 01-1.28 1.472c-.437.384-.88.576-1.328.576-.384 0-.682-.144-.896-.432C.71 5.96.608 5.587.608 5.128c0-.554.134-1.082.4-1.584A4.936 4.936 0 012.08 2.216a5.33 5.33 0 011.392-.896c.491-.224.95-.336 1.376-.336.31 0 .528.054.656.16.14.096.208.214.208.352 0 .096-.026.171-.08.224a.585.585 0 01-.112.096.41.41 0 00-.24-.176 1.084 1.084 0 00-.4-.064c-.416 0-.82.123-1.216.368-.384.246-.725.56-1.024.944a5.596 5.596 0 00-.72 1.2c-.17.406-.256.779-.256 1.12 0 .256.048.454.144.592a.516.516 0 00.416.192c.31 0 .678-.202 1.104-.608A9.588 9.588 0 004.592 3.88c.032-.149.06-.282.08-.4.032-.117.07-.266.112-.448a1.7 1.7 0 01.224-.512c.128-.202.326-.304.592-.304.054 0 .107.006.16.016a.56.56 0 01.176.032c0 .171-.053.486-.16.944-.096.448-.24.976-.432 1.584a27.566 27.566 0 01-.64 1.856c.352-.17.694-.389 1.024-.656.342-.266.651-.57.928-.912.278-.352.496-.73.656-1.136l.208.16c-.16.48-.416.918-.768 1.312-.352.395-.73.736-1.136 1.024a7.22 7.22 0 01-1.088.672 18.531 18.531 0 01-.944 1.952c-.33.598-.677 1.072-1.04 1.424-.352.352-.73.528-1.136.528zm-.048-.512c.214 0 .502-.213.864-.64.374-.416.774-1.136 1.2-2.16a17.84 17.84 0 00-1.2.656 4.59 4.59 0 00-.896.736c-.234.256-.352.539-.352.848 0 .171.038.304.112.4.075.107.166.16.272.16z","fill":"currentColor"}})])
          )
        }
      }
    